
export default {
  data() {
    return {
      tableLists: [],
      listLoading: false,
      currentLocalData: [],
      dataSubKey: '',
      listQuery: {
        p: 1,
        limit: 20,
        total: 0
      }
    }
  },
  props: {
    urlFunc: {
      type: Function,
      default: null
    },
    localData: {
      type: Array,
      default() {
        return []
      }
    },
    showPage: {
      type: Boolean,
      default: false
    },
    subKey: {
      type: String,
      default: ''
    },
    otherQuery: {
      type: Object,
      default: null
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    }
  },
  watch: {
    otherQuery: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.listQuery = Object.assign(this.listQuery, newVal)
          // this.fetchTableData()
        }
      },
      deep: true // 深度观察 obj 的变化
    },
    localData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.currentLocalData = newVal
          this.fetchTableData()
        }
      },
      deep: true // 深度观察 obj 的变化
    }
  },
  methods: {
    fnInitData() {
      if (this.otherQuery) {
        this.listQuery = Object.assign(this.listQuery, this.otherQuery)
      }
      if (this.localData && this.localData.length > 0) {
        this.currentLocalData = this.localData
      }
    },
    fetchTableData() {
      // 优先获取本地数据
      if (this.currentLocalData && this.currentLocalData.length > 0) {
        this.tableLists = this.currentLocalData
        this.listLoading = false
        return
      }
      if (this.urlFunc == null) {
        return
      }
      this.listLoading = true
      this.urlFunc(this.listQuery).then((res) => {
        this.listLoading = false
        this.$emit('data-from-server', res.data)
        this.tableLists = this.subKey ? res.data[this.subKey] : res.data
        if (this.showPage) {
          this.listQuery.total = parseInt(res.data.count)
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleSelectionChange(e) {
      this.$emit('selection-change', e)
    }
  }
}
